// extracted by mini-css-extract-plugin
module.exports = {"MarketplaceItemDataRow":"MarketplaceItemDataRow_MarketplaceItemDataRow__31DAn","Title":"MarketplaceItemDataRow_Title__22bFZ","Content":"MarketplaceItemDataRow_Content__1Ou37"};